
import {Component, Prop, Vue} from "vue-property-decorator";
import {alertModule, authModule, usersModule} from "@/store";
import {eventBus} from "@/main";
import {MdbsCore} from "@/api/tsclient";
import UserPasswordResetDto = MdbsCore.UserPasswordResetDto;

@Component
export default class UserPasswordResetView extends Vue {
  @Prop() readonly userId!: string;
  @Prop() readonly passwordResetToken!: string;

  passwordChanged: boolean = false;
  passwordString1: string = "";
  passwordString2: string = "";
  showPassword: boolean = false;

  valid: boolean = false;

  rules: any = {
    required: (v: any) => !!v || 'Wird Benötigt.',
    min: (v: any) => v.length >= 6 || 'Mindestens 6 Zeichen',
    uppercase: (v: any) => (/[A-Z]/.test(v)) || 'Mindestens 1 Großbuchstabe',
    lowercase: (v: any) => (/[a-z]/.test(v)) || 'Mindestens 1 Kleinbuchstabe',
    number: (v: any) => (/[0-9]/.test(v)) || 'Mindestens eine Zahl',
  };

  ruleSamePassword(value: any) {
    return value === this.passwordString1 || 'Neue Passwörter müssen gleich sein'
  }

  get passwordIsOkToChange() {
    // TODO fancy password change rules
    return this.valid &&
        this.passwordString1 != null && this.passwordString1.length > 0 &&
        (this.showPassword ||
            (this.passwordString2 != null && this.passwordString2.length > 0 &&
                this.passwordString1 === this.passwordString2));
  }

  async changePassword() {
    try {
      await authModule.setTokenForPasswordReset(this.passwordResetToken)
      await usersModule.resetPassword(new UserPasswordResetDto({
        id: this.userId,
        newPasswordString: this.passwordString1
      }));
      localStorage.removeItem("token");
      this.passwordChanged = true;
    } catch (e) {
      await alertModule.error("Passwort konnte nicht geändert werden.");
    }
  }

  async mounted() {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
  }

  async gotoLogin() {
    eventBus.$emit('force-logout');
  }
}
